import {
    BackendClient,
    type BackendClientParameters,
} from "@internal/backstage-plugin-utility-common";

/**
 * Parameters for creating a GoogleClient.
 *
 * @public
 */
export type GoogleClientOptions = Omit<
    BackendClientParameters,
    "targetPluginId"
>;

/**
 * Client to fetch data from the google backend.
 *
 * Sub-clients are mounted automatically at construction time by
 * `ClientRegistry` as each module's `-common` package is evaluated.
 *
 * @public
 */
export class GoogleClient extends BackendClient {
    /**
     * Creates a new GoogleClient.
     *
     * @param options - Discovery and identity APIs required to make authenticated requests.
     */
    constructor(options: GoogleClientOptions) {
        super({ ...options, targetPluginId: "google" });
    }
}
